<template>
  <div>
    <label :for="field.id">{{ field.label[currentLanguage] }} <span v-if="field.required" class="required">*</span></label>
    <input :name="field.name" :value="value" @change="$emit('input', $event.target.value);$emit('change', '')" :type="field.subtype" :id="field.id" :readonly="field.readonly" :disabled="disabledStatus(field.disabled)" :multiple="field.multi" :required="field.required">
    <p class="small" v-if="field.description[currentLanguage]" v-html="field.description[currentLanguage]"></p>
  </div>
</template>

<script>
export default {
  props: ['value', 'field', 'currentLanguage', 'disabledStatus']
}
</script>



// WEBPACK FOOTER //
// src/components/elements/input.vue